import React from 'react';
import { LogIn, RefreshCw } from 'lucide-react';
import { Button } from '../../../components/ui/Button';
import { Card } from '../../../components/ui/Card';
import { useAuth } from '../context/AuthContext';

const env = process.env as Record<string, string | undefined>;
const CORE_APP_URL = (env.REACT_APP_CORE_URL ?? env.REACT_APP_CORE_APP_URL ?? '').replace(/\/$/, '');

const buildCoreLoginUrl = () => {
  if (!CORE_APP_URL) return null;

  try {
    const target = new URL('/login', CORE_APP_URL);
    target.searchParams.set('redirect', window.location.href);
    return target.toString();
  } catch {
    return null;
  }
};

export const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { status, refreshSession } = useAuth();

  if (status === 'loading') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
        <Card className="w-full max-w-sm border-slate-200 p-6 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-light text-primary">
            <RefreshCw size={20} className="animate-spin" />
          </div>
          <p className="mt-4 text-sm font-semibold text-slate-700">Validando sessao...</p>
        </Card>
      </div>
    );
  }

  if (status === 'unauthenticated') {
    const coreLoginUrl = buildCoreLoginUrl();

    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 px-6">
        <Card className="w-full max-w-md border-slate-200 p-6 text-center">
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-2xl bg-primary-light text-primary">
            <LogIn size={20} />
          </div>
          <h1 className="mt-4 text-lg font-bold text-slate-900">Sessao necessaria</h1>
          <p className="mt-2 text-sm text-slate-500">
            Entre pelo aplicativo Core e acesse a EBD pelo seletor de aplicativos.
          </p>
          <div className="mt-5 grid gap-3 sm:grid-cols-2">
            <Button type="button" variant="ghost" className="h-11 border border-slate-200" onClick={refreshSession}>
              Tentar novamente
            </Button>
            {coreLoginUrl ? (
              <Button type="button" className="h-11" onClick={() => window.location.assign(coreLoginUrl)}>
                Entrar pelo Core
              </Button>
            ) : null}
          </div>
        </Card>
      </div>
    );
  }

  return <>{children}</>;
};
